// Helper for printing service tickets
import OrderService from '@/services/OrderService';

export async function printServiceTicket(orderID, serviceTicketID, bedding = true, towelFolding = false, hanging = false) {
  try {
    const params = serviceTicketID
      ? { tickets: [serviceTicketID], bedding, towel_folding: towelFolding, hanging }
      : {};
    await OrderService.printServiceTickets(orderID, params);
  } catch (e) {
    // Optionally show a user-facing error or log
    console.error('Error printing service ticket:', e);
  }
}

export async function printServiceTicketQpup(orderID, serviceTicketID, bedding = true, towelFolding = false, hanging = false) {
  try {
    const params = serviceTicketID
      ? { tickets: [serviceTicketID], bedding, towel_folding: towelFolding, hanging }
      : {};
    await OrderService.printServiceTicketsQpup(orderID, params);
  } catch (e) {
    // Optionally show a user-facing error or log
    console.error('Error printing service ticket:', e);
  }
}